import http from "../utils/http"
import axios from 'axios'
import { Message } from 'element-ui'
const baseUrl = ''

export const upload = params => http.post(`${baseUrl}/upload`, params)

/**
 * 获取阿里云OSS上传凭证
 * /app/teacher/org
 */

export const uploadSign = () => http.get(`${baseUrl}/oss/sign`)


/**
 *上传图片到阿里云OSS
 * @param {host,data}
 */
export const aliyunUpload = (host, data) => new Promise((resolve) => {
    axios.post(host, data).then((res) => {
        if(res.status === 200) {
            resolve(res)
            // Message.success({
            //     message:'上传成功'
            // })
        }else {
            Message.success({
                type:'error',
                message:'上传失败'
            })
        }
    })
})
